import { render, staticRenderFns } from "./IconCollections.vue?vue&type=template&id=4dfaecf0&"
import script from "./IconCollections.vue?vue&type=script&lang=js&"
export * from "./IconCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports